export default __webpack_public_path__ + "static/media/excel.880444c8.svg";